import { useState } from "react";
import CalculatorPanel from "../components/CalculatorPanel.jsx";
import LeadForm from "../components/LeadForm.jsx";
import OpportunityPlan from "../components/OpportunityPlan.jsx";
import ProductGrid from "../components/ProductGrid.jsx";
import RoiTable from "../components/RoiTable.jsx";
import SectionTitle from "../components/SectionTitle.jsx";

const pageMeta = {
  fd: {
    titleKey: "fd",
    text: "Compare the official FD ROI plan slabs from 6 months to 60 months with maturity examples."
  },
  rd: {
    titleKey: "rd",
    text: "Explore the Aadarsh Thev Yojana recurring deposit ROI plan with monthly deposit maturity examples."
  },
  daily: {
    titleKey: "daily",
    text: "Daily collection products plus the collection officer and financial advisor opportunity plan."
  },
  gold: {
    titleKey: "gold",
    text: "Estimate loan eligibility against gold with transparent demo LTV and purity assumptions."
  }
};

export default function ProductPage({ type, t, products }) {
  const [selected, setSelected] = useState(products[0]);
  const meta = pageMeta[type];
  const roiTable = products.find((product) => product.roiTable)?.roiTable;
  const opportunityPlan = products.find((product) => product.opportunityPlan)?.opportunityPlan;

  return (
    <section className="section-shell py-14">
      <SectionTitle title={t.sections[meta.titleKey]} text={meta.text} />
      <ProductGrid
  products={products}
  cta={t.actions.enquire}
  onSelect={(product) => {
    setSelected(product);

    setTimeout(() => {
      document
        .getElementById("lead-form")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }}
/>
      <RoiTable table={roiTable} />
      <OpportunityPlan plan={opportunityPlan} />
      <div
  id="lead-form"
  className="mt-10 grid gap-6 lg:grid-cols-[1.25fr_0.75fr]"
>
        <CalculatorPanel type={type} product={selected} roiTable={roiTable} t={t} />
        <LeadForm t={t} type={type === "fd" ? "fd" : type === "rd" ? "rd" : type === "daily" ? "daily" : "gold"} product={selected?.name || ""} />
      </div>
    </section>
  );
}
